module.exports = __webpack_public_path__ + "public/images/slider/nedbay.9d580bd1eb471ccbdf92c9ced194ca07.png";